import PropTypes from 'prop-types';
import './desktopViewProfile.scss';
import React, { useState } from 'react';

const EmployeeProfile = ({ employee, employeeNameMenu, projectDetails }) => {
  const [imageError, setImageError] = useState(false);

  const getInitial = (name) => (name ? name.charAt(0).toUpperCase() : '');

  const handleImageError = () => {
    setImageError(true);
  };

  return (
    <div className="employee-profile-container">
      <div className="employee-title">Employee profile</div>
      <div className="employee-details">
        <div className="employee-picture">
          {!imageError && employee.photoSignedUrl ? (
            <img
              src={employee.photoSignedUrl}
              alt={employee.fullName}
              className="employee-picture-image"
              onError={handleImageError}
              role="presentation"
            />
          ) : (
            <div className="employee-picture-placeholder">
              {getInitial(employee.fullName)}
            </div>
          )}
        </div>
        <div className="employee-info">
          <div className="employee-personal-details">
            <div className="employee-name">{employee.fullName}</div>
            <div className="employee-name-details">
              {employeeNameMenu.map((item) => (
                <div className={`employee-${item.label}`} key={item.label}>
                  <img src={item.icon} alt={`${item.label} Icon`} />
                  <div className={`employee-${item.label}-text`}>
                    {item.text}
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="employee-project-details">
            {projectDetails.map((item) => (
              <div
                className={`employee-${item.label
                  .toLowerCase()
                  .split(' ')
                  .join('-')}`}
                key={item.label}
              >
                <div className="employee-project-details-label">
                  {item.label}
                </div>
                <div className="employee-project-details-text">{item.text}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

EmployeeProfile.propTypes = {
  employee: PropTypes.array.isRequired,
  employeeNameMenu: PropTypes.arrayOf(PropTypes.object).isRequired,
  projectDetails: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default EmployeeProfile;
